import {DashboardViewRegion} from "../../../dashboard-view-regions/types/dashboard-view-regions.types";

/**
 * Unique identifier for the dashboard study viewer state.
 */
export const dashboardStudyViewerStateUniqueIdentifier = '__DashboardStudyViewer__';

export class InitDashboardStudyViewer {
  static readonly type = `${dashboardStudyViewerStateUniqueIdentifier} ${InitDashboardStudyViewer.name}`;
}

export class FocusDashboardViewRegion {
  static readonly type = `${dashboardStudyViewerStateUniqueIdentifier} ${InitDashboardStudyViewer.name}`;

  constructor(public viewRegion: DashboardViewRegion) {}
}

export class StartDashboardViewerPapaya {
  static readonly type = `${dashboardStudyViewerStateUniqueIdentifier} ${StartDashboardViewerPapaya.name}`;

  constructor(public viewRegion: DashboardViewRegion) {}
}
